export default __webpack_public_path__ + "static/gift-card-9.url-5678e1260deee9ad3a1a2e5120c26821.svg";